







































import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
import store from "@/store";
import { Getter, Action } from "vuex-class";

@Component
export default class distributeConfirmModal extends Vue {
  @Prop()
  show!: boolean;

  handleOk() {
    this.$emit("ok");
  }
  handleCancel() {
    this.$emit("cancel");
  }
  @Getter("distributeTypeParameter") distributeTypeParameter!: Object;
  @Getter("section") section!: Object;
  @Action("changeDistributeParameter") changeDistributeParameter!: Function;
  @Getter("hasOpenSMSVerify") hasOpenSMSVerify!: boolean;

  closeModla() {
    this.changeDistributeParameter({ openDistributeRewardModal: false });
  }
}
